import React from 'react';
import { TaskManagement } from '@/widgets/task-management';

export const TaskManagementPage: React.FC = () => {
  return (
    <div className="space-y-8">
      <TaskManagement />
    </div>
  );
};